var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlatePref(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 1.66669V18.3334H0V4.29827L2.5 1.66669H20ZM2.5 4.29827H5V6.92985H2.5V4.29827ZM6.66667 4.29827H9.16667V6.92985H6.66667V4.29827ZM13.3333 4.29827H10.8333V6.92985H13.3333V4.29827ZM15 4.29827H17.5V6.92985H15V4.29827ZM2.5 8.68423H5V11.3158H2.5V8.68423ZM6.66667 8.68423H9.16667V11.3158H6.66667V8.68423ZM13.3333 8.68423H10.8333V11.3158H13.3333V8.68423ZM15 8.68423H17.5V11.3158H15V8.68423ZM5 13.0702H2.5V15.7018H5V13.0702ZM9.16667 13.0702H6.66667V15.7018H9.16667V13.0702ZM10.8333 13.0702H13.3333V15.7018H10.8333V13.0702ZM17.5 13.0702H15V15.7018H17.5V13.0702Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatePref);
export default __webpack_public_path__ + "static/media/PlatePref.513ef337f0c44f28b4b1d85a321ba33f.svg";
export { ForwardRef as ReactComponent };